"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizeRoles = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var normalizeRoles = function normalizeRoles(roles) {
  var mainRoles = roles.mainRoles,
      customRoles = roles.customRoles;
  var normalizedRoles = [];
  var mainRolesTitle = {
    id: 'main-role-title',
    name: 'title',
    value: 'PRIMARY USER ROLE'
  };
  var customRolesTitle = {
    id: 'custom-role-title',
    name: 'title',
    value: 'CUSTOM USER ROLE'
  };
  var separator = {
    id: 'separator',
    name: 'separator',
    value: 'separator'
  };
  normalizedRoles.push(mainRolesTitle);
  normalizedRoles.push.apply(normalizedRoles, (0, _toConsumableArray2.default)(normalizeUserRoles(mainRoles)));

  if (Array.isArray(customRoles)) {
    normalizedRoles.push(separator);
    normalizedRoles.push(customRolesTitle);
    normalizedRoles.push.apply(normalizedRoles, (0, _toConsumableArray2.default)(normalizeUserRoles(customRoles)));
  }

  return normalizedRoles;
};

exports.normalizeRoles = normalizeRoles;

var normalizeUserRoles = function normalizeUserRoles(roles) {
  return roles.map(function (role) {
    return {
      id: role.id,
      name: role.label,
      value: role.name
    };
  });
};